<!-- Copyright © 2024 Insurance Services Office, Inc. All rights reserved -->

<div
  class="item root-menu-item"
  style="margin-top: 4px"
  routerLinkActive="active-link"
>
  <i class="fa-solid fa-file"></i>
  <a routerLink="/file-explorer">File Explorer</a>
</div>
<mat-accordion class="">
  <mat-expansion-panel class="item" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <i class="fa-solid fa-gear"></i> {{ Constants.LEFT_MENU_Configuration }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-receipt"></i
      ><a routerLink="/recipe">{{ Constants.COMMON_Recipe }}</a>
    </mat-panel-title>
    <br />
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-users-gear"></i
      ><a routerLink="/customer">{{ Constants.COMMON_Customer }}</a>
    </mat-panel-title>
    <br />
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-table"></i
      ><a routerLink="/dataset">{{ Constants.COMMON_Dataset }}</a>
    </mat-panel-title>
  </mat-expansion-panel>
</mat-accordion>
<mat-accordion class="">
  <mat-expansion-panel class="item" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <i class="fa-solid fa-database"></i> {{ Constants.LEFT_MENU_Storage }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-cloud-arrow-up"></i
      ><a routerLink="/storage/raw-upload">{{
        Constants.LEFT_MENU_Raw_Upload
      }}</a>
    </mat-panel-title>
    <br />
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-layer-group"></i
      ><a routerLink="/harmonized-explorer">{{
        Constants.LEFT_MENU_Harmonized_Explorer
      }}</a>
    </mat-panel-title>
  </mat-expansion-panel>
</mat-accordion>
<mat-accordion class="">
  <mat-expansion-panel class="item" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <i class="fa-solid fa-gear"></i> {{ Constants.LEFT_MENU_Reports }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-receipt"></i
      ><a routerLink="/reports/dashboard">{{ Constants.COMMON_Dashboard }}</a>
    </mat-panel-title>
    <br />
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-clipboard-list"></i
      ><a routerLink="/reports/logs">{{ Constants.LEFT_MENU_Logs }}</a>
    </mat-panel-title>
    <br />
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-chart-column"></i
      ><a routerLink="/reports/kpi">{{ Constants.Kpi_Recipe_Report }}</a>
    </mat-panel-title>
    <br />
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-folder-tree"></i
      ><a routerLink="/reports/folder-pattern-search">{{
        Constants.Folder_Pattern_Search_Report
      }}</a>
    </mat-panel-title>
    <br />
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-folder"></i
      ><a routerLink="/reports/client-statistics">{{
        Constants.LEFT_MENU_Customer_Metrics
      }}</a>
    </mat-panel-title>
    <br />
    <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-calendar-days"></i
      ><a routerLink="/reports/client-files-processed-monthly">{{
        Constants.LEFT_MENU_Client_Files_Processed_Monthly
      }}</a>
    </mat-panel-title>
    <br />

    <mat-accordion class="">
      <mat-expansion-panel class="item" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fa-solid fa-gear"></i>
            {{ Constants.LEFT_MENU_Developers }}
          </mat-panel-title>
        </mat-expansion-panel-header>
            <mat-panel-title class="second" routerLinkActive="active-link">
      <i class="fa-solid fa-table-columns"></i
      ><a routerLink="/reports/table-metadata">{{
        Constants.LEFT_MENU_Table_Metadata_Report
      }}</a>
    </mat-panel-title>
    <br />
      </mat-expansion-panel>
    </mat-accordion>
  </mat-expansion-panel>
</mat-accordion>
